import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

export function useGetWorkflowOnOffState({ companyId }: { companyId: string }) {
  return useQuery({
    queryKey: ['workflow-toggle', companyId],
    queryFn: async (): Promise<ApiResponse> => {
      const response = await axios.get(`companies/${companyId}`)
      return response.data
    },
  })
}
